import { analyticEmployeeAdvocacyActions } from 'store/actions';
import { IAnalyticEmployeeAdvocacyMeta } from 'store/actions/analytics/ROI/employeeAdvocacy';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<
  IAnalyticEmployeeAdvocacyMeta,
  GenericResponse
>(analyticEmployeeAdvocacyActions);
